// Keep this object in sync with the analogous backend one in lib/terminal/sample_locations.rb
// These fixtures are also used in File.test.js unit tests
export const locales = {
  IE: {
    location: {
      name: 'HQ',
      line1: 'Grand Canal Street Lower',
      city: 'Dublin',
      country: 'IE',
      postal: 'D02 H210',
    },
    currency: 'eur',
  },
  NL: {
    location: {
      name: 'HQ',
      line1: 'Singel 542',
      city: 'Amsterdam',
      country: 'NL',
      postal: '1017 AZ',
    },
    currency: 'eur',
  },
  DE: {
    location: {
      name: 'HQ',
      line1: 'Stresemannstraße 123',
      city: 'Berlin',
      country: 'DE',
      postal: '10963',
    },
    currency: 'eur',
  },
  FR: {
    location: {
      name: 'HQ',
      line1: '10 Boulevard Haussmann',
      city: 'Paris',
      country: 'FR',
      postal: '75009',
    },
    currency: 'eur',
  },
  NZ: {
    location: {
      name: 'HQ',
      line1: '203 Victoria Street',
      city: 'Auckland Central',
      state: 'Auckland',
      country: 'NZ',
      postal: '1010',
    },
    currency: 'eur',
  },
  AU: {
    location: {
      name: 'HQ',
      line1: '1234 Victoria Street',
      city: 'Melbourne',
      state: 'Victoria',
      country: 'AU',
      postal: '3000',
    },
    currency: 'aud',
  },
  CA: {
    location: {
      name: 'HQ',
      line1: '3040 Bur Oak Ave',
      city: 'Markham',
      state: 'ON',
      country: 'CA',
      postal: 'L6B 0R1',
    },
    currency: 'cad',
  },
  SG: {
    location: {
      name: 'HQ',
      line1: '19 Keppel Road',
      city: 'Singapore',
      country: 'SG',
      postal: '089058',
    },
    currency: 'sgd',
  },
  US: {
    location: {
      name: 'HQ',
      line1: '1272 Valencia Street',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      postal: '94110',
    },
    currency: 'usd',
  },
  GB: {
    location: {
      name: 'HQ',
      line1: '448A Crownhill Rd',
      city: 'Plymouth',
      country: 'GB',
      postal: 'PL5 2QT',
    },
    currency: 'gbp',
  },
  // No hero user yet, just picked an arbitrary store/address for now
  AT: {
    location: {
      name: 'AT',
      line1: 'Hernalser Hauptstraße 11',
      city: 'Vienna',
      country: 'AT',
      postal: '1170',
    },
    currency: 'eur',
  },
  // http://www.becolor.be
  BE: {
    location: {
      name: 'BE',
      line1: 'Rue du Lombard 5-9',
      city: 'Bruxelles',
      country: 'BE',
      postal: '1000',
    },
    currency: 'eur',
  },
  // https://teselskabet.dk/
  DK: {
    location: {
      name: 'DK',
      line1: 'Baunegårdsvej 3A',
      city: 'Gentofte',
      country: 'DK',
      postal: '2820',
    },
    currency: 'eur',
  },
  // https://sport2001.com/
  ES: {
    location: {
      name: 'ES',
      line1: 'Calle Pedro Laborde 24',
      city: 'Madrid',
      state: 'Madrid',
      country: 'ES',
      postal: '28018',
    },
    currency: 'eur',
  },
  // No hero user yet, just picked an arbitrary store/address for now
  SE: {
    location: {
      name: 'SE',
      line1: 'Hornsgatan 98',
      city: 'Stockholm',
      country: 'SE',
      postal: '118 21',
    },
    currency: 'eur',
  },
  MY: {
    location: {
      name: 'MY',
      line1: '170, Jalan Maarof',
      city: 'Bangsar',
      state: 'Kuala Lumpur',
      country: 'MY',
      postal: '59100',
    },
    currency: 'myr',
  },
  HK: {
    location: {
      name: 'HK',
      line1: '8 Wang Hoi Road 98',
      city: 'Kowloon Bay',
      state: 'Kowloon',
      country: 'HK',
    },
    currency: 'hkd',
  },
};
